import { FC } from "react";
import { useDispatch } from "react-redux";

import { CardSwitchModelsWrapperProps } from "./types";
import CardSkeleton from "../CardSkeleton/CardSkeleton";
import CardSwitch from "../CardSwitch/CardSwitch";
import DataLoadError from "../DataLoadError";
import { changeModelStatus } from "../../store/models/slice";
import { mapModelIcon, ModelIcons } from "../../types/models";


const CardSwitchModelsWrapper: FC<CardSwitchModelsWrapperProps> = ({
  models,
  active = true,
  skeletonCount = 1,
  loading,
  error,
  onRetry,
  planLocked = false,
  onUpgrade,
}) => {
  const dispatch = useDispatch();

  const handleSwitchChange = (id: number, status: boolean) => {
    if (planLocked) return;
    dispatch(changeModelStatus({ id: String(id), status }));
  };

  const renderSkeletons = () => {
    return Array.from({ length: skeletonCount }).map((_, index) => (
      <CardSkeleton key={index} />
    ));
  };

  if (loading) return renderSkeletons();

  if (!models && error) {
    return (
      <DataLoadError
        message={error}
        onRetry={onRetry}
      />
    );
  }

  if (!models) return renderSkeletons();

  return (
    <div>
      {models.map((model) => (
        <CardSwitch
          key={model.id}
          id={Number(model.id)}
          title={`${model.name} ${model.data.version}`}
          icon={mapModelIcon(model.name.toLowerCase() as ModelIcons)}
          onSwitchChange={handleSwitchChange}
          active={planLocked ? Boolean(model.is_active_user) : active}
          isPlanLocked={planLocked}
          onUpgrade={onUpgrade}
        />
      ))}
    </div>
  );
};

export default CardSwitchModelsWrapper;